module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/contact-c3a5efc817b432214a6071aeec2ea509.svg&quot;;"